module.exports = __webpack_public_path__ + "static/media/03_crisalide.bfa38ca2.jpg";